import * as React from "react";

function SapSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={62.106}
      height={30.739}
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x2={0.011}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#00b8f1" />
          <stop offset={0.22} stopColor="#06a5e5" />
          <stop offset={0.794} stopColor="#1870c5" />
          <stop offset={1} stopColor="#1d61bc" />
        </linearGradient>
      </defs>
      <path d="M0 0v30.724h31.386L62.106 0H0z" fill="url(#prefix__a)" />
      <path
        d="M39.754 27.584v2.291h.346v-.991h.389l.627.994h.389l-.67-.994a.62.62 0 00.605-.649c0-.452-.276-.649-.821-.649zm.346.3h.476c.234 0 .5.038.5.324 0 .358-.267.389-.562.389h-.411zm.432-1.146a2 2 0 101.989 1.989 1.971 1.971 0 00-1.989-1.987zm0 .324a1.666 1.666 0 010 3.329 1.665 1.665 0 010-3.329z"
        fill="#1870c5"
      />
      <path
        d="M37.213 14.701h-1.345V9.778h1.345c1.8 0 3.228.592 3.228 2.43 0 1.9-1.431 2.493-3.228 2.493m-14.489 3.52a5.591 5.591 0 01-1.958-.347l1.939-6.115h.042l1.9 6.132a5.708 5.708 0 01-1.919.331M36.857 5.778h-6.113v14.536l-5.34-14.536h-5.291l-4.566 12.153c-.482-3.063-3.655-4.124-6.15-4.914-1.644-.53-3.394-1.307-3.378-2.168.014-.7.94-1.357 2.767-1.26a9.924 9.924 0 014.474 1.2l2.124-3.7A16.517 16.517 0 008.46 5.453h-.014a8.417 8.417 0 00-6.114 2.236 5.172 5.172 0 00-1.463 3.567 4.789 4.789 0 002.1 4.266 14.427 14.427 0 004.157 1.9c1.7.524 3.085.981 3.069 1.956a1.417 1.417 0 01-.4.95 2.689 2.689 0 01-1.971.622 8.467 8.467 0 01-5.063-1.444L.868 23.261a14.105 14.105 0 006.92 1.841h.319a8.381 8.381 0 005.261-1.766l.224-.2-.612 1.644h5.551l.932-2.835a10.617 10.617 0 006.45.025l.9 2.809h9.058V18.91h1.976c4.773 0 7.6-2.429 7.6-6.507 0-4.538-2.745-6.619-8.589-6.619"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SapSvg;
